import React from "react";
import { Text } from "@chakra-ui/react";

const sectionTextStyle = {
  fontWeight: "700",
  fontSize: "18px",
  lineHeight: "32px",
  color: "#0E3665",
  fontFamily: "Nunito",
  marginTop: "24px",
};

const Heading = ({ headingLabel, ...props }) => {
  return (
    <Text {...sectionTextStyle} {...props}>
      {headingLabel}
    </Text>
  );
};

export default Heading;
